export const sms_input = {
  letter_count: 'Символы: {count} / {total}',
  sms_count: 'Кол-во смс: {count}'
};
